<template>
  <div class="input-group">
    <div class="input-group-prepend">
      <sel-tipo-documento
        :allowEmpty="allowEmpty"
        @selectChange="onTypeChange"
        :nameField="documentType"
        :emptyLabel="emptyLabel"
        :typeDefault="'cpf'"
        class="document-type-selector"
      />
    </div>
    <b-input
      v-model="documentNumber"
      :placeholder="placeholder"
      class="form-control"
      :class="{ 'is-invalid': isInvalid }"
      v-mask="mask"
      :trim="true"
    />
    <b-badge
      v-if="showMinLengthWarning"
      v-b-tooltip.hover
      :title="$t('Necessário 3 dígitos no mínimo')"
      variant="danger"
      class="mb-1"
    >
      + {{ 3 - documentNumber.length }}
    </b-badge>
    <small v-if="isInvalid" class="text-danger">{{ $t('Informe um documento válido') }}</small>
  </div>
</template>

<script>
export default {
  props: {
    document: {
      type: String,
      default: ''
    },
    documentType: {
      type: String,
      default: ''
    },
    validate: {
      type: Boolean,
      default: true
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    emptyLabel: {
      type: String,
      default: 'Selecione'
    }
  },
  data() {
    return {
      documentNumber: '',
      isInvalid: false
    };
  },
  computed: {
    mask() {
      return this.documentType === 'cpf' ? '###.###.###-##' : '################';
    },
    placeholder() {
      return this.documentType === 'cpf' ? '000.000.000-00' : 'Documento';
    },
    showMinLengthWarning() {
      return (
        this.documentNumber &&
        this.documentNumber.length > 0 &&
        this.documentNumber.length < 3 &&
        this.documentType !== 'cpf'
      );
    }
  },
  watch: {
    documentNumber() {
      this.validateDocument();
    },
    document(value) {
      if (!this.documentNumber) {
        this.documentNumber = value;
      }
    },
    documentType() {
      this.validateDocument();
    }
  },
  methods: {
    onTypeChange(name, value) {
      this.$emit('typeChange', name, value);
      this.validateDocument();
    },
    validateDocument() {
      if (!this.validate) {
        this.emitDocument();
        return;
      }

      if (!this.documentNumber) {
        this.isInvalid = true;
        return;
      }

      if (this.documentType === 'cpf') {
        this.isInvalid = this.documentNumber.replace(/\D/g, '').length !== 11;
      } else {
        this.isInvalid = this.documentNumber.length < 3;
      }

      this.emitDocument();
    },
    emitDocument() {
      const cleanDocument = this.documentNumber.replace(/\D/g, '');
      if (this.document !== cleanDocument) {
        this.$emit('input', cleanDocument, this.isInvalid);
      }
    }
  }
};
</script>

<style lang="scss">
.document-type-selector {
  width: 120px;
  min-width: 120px;
  height: 100%;
  display: flex;
  align-items: center;
  background: white;
  .multiselect__tags {
    border-right: none !important;
    border-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-radius: 0.25rem 0 0 0.25rem !important;
  }
}

small.text-danger {
  display: block;
  width: 100%;
  margin-top: 4px;
}
</style>
